import { render, staticRenderFns } from "./DelServiceBusiness.vue?vue&type=template&id=8c41f5bc&scoped=true"
import script from "./DelServiceBusiness.vue?vue&type=script&lang=js"
export * from "./DelServiceBusiness.vue?vue&type=script&lang=js"
import style0 from "./DelServiceBusiness.vue?vue&type=style&index=0&id=8c41f5bc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c41f5bc",
  null
  
)

export default component.exports